var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-badge",attrs:{"id":_vm.id + '___FB_badge_'}},[(_vm.copy !== null)?_c('span',{staticClass:"badge",class:[_vm.stylingBg, _vm.stylingText]},[_vm._v(" "+_vm._s(_vm.copy)+" ")]):_c('span',{staticClass:"badge",class:[_vm.stylingBg, _vm.stylingText]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }